import {
    captionClassName,
    dropdownItemSlotClassNames,
    dropdownSlotClassNames,
    pxToRem,
    searchableDropdownClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const FilterLocation: StyleRule<{
    hasValue: boolean;
}> = ({ hasValue, theme }) => ({
    marginBottom: pxToRem(16),
    [theme.screen.laptop]: {
        marginBottom: 0,
    },
    [`& .currentLocationButton`]: {
        alignSelf: 'start',
        marginTop: pxToRem(16),
        marginLeft: pxToRem(18),
        [theme.screen.laptop]: {
            marginLeft: 0,
        },
    },
    [`& .currentLocationNote`]: {
        marginTop: pxToRem(16),
        marginLeft: pxToRem(18),
        fontSize: pxToRem(14),
        lineHeight: pxToRem(18),
        color: theme.siteVariables.colors.danger[200],

        [theme.screen.laptop]: {
            marginTop: pxToRem(20),
            marginLeft: 0,
            fontSize: pxToRem(20),
            lineHeight: pxToRem(26),
        },
    },
    [`& .${searchableDropdownClassName}`]: {
        [`& .${dropdownSlotClassNames.selectedItems}`]: {
            paddingLeft: hasValue ? pxToRem(12) : pxToRem(40),
            [theme.screen.laptop]: {
                paddingLeft: pxToRem(12),
            },
        },
    },
});

export const Prefix: StyleRule = ({ theme }) => ({
    [`&.${captionClassName}`]: {
        color: theme.siteVariables.colors.grey[300],
        paddingRight: pxToRem(4),
    },
});

export const HeaderLocation: StyleRule = () => ({
    whiteSpace: 'break-spaces',
});

export const SuggestionDropdown: StyleRule = () => ({
    [`& .${dropdownItemSlotClassNames.main}`]: {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'baseline',
        flexGrow: 'initial',
    },
    [`& .${dropdownItemSlotClassNames.header}`]: {
        fontSize: pxToRem(16),
    },
});
